.hidden-content > div span:nth-child(2) > i {
  display: inline-block;
  transition: transform 0.3s ease;
}
.hidden-content > div span:nth-child(2) > i:hover {
  transform: translateY(5px); 
}
.oculto {
  opacity: 0;
  visibility: hidden;
  max-height: 0;
  overflow: hidden;
  transition: all 0.4s ease;
}
.visible {
  opacity: 1;
  visibility: visible;
  max-height: 38rem; /* lo suficientemente grande */
  transition: all 0.4s ease;
  overflow: auto;
}
.hidden-content > article {
  margin-top: 1rem;
  padding: 1rem;
  height: 38rem;
  background-color: var(--blue-2-50);
}
.hidden-content > div {
  border: solid 1px;
  border-color: transparent transparent white transparent;
}